import type { ListBuilderList } from '../../../types';
import { createStandardTaskColumns } from '../columns';

/**
 * This Week Tasks list configuration
 * Shows pending tasks due this week
 */
export const thisWeekTasksList: ListBuilderList = {
	id: 'this-week-tasks',
	cacheTTL: 300000,
	name: 'This Week',
	type: 'default',
	active: true,
	sortOrder: 4,
	activeFilters: [
		'taskKeywords',
		'taskStatus',
		'taskPriority',
		'taskLinkType',
		'taskAssignedUser',
		'taskTeams',
		'taskClient',
		'taskClientRep',
		'taskLeadOrCustomer',
		'taskDueDateRange',
		'taskExternalCalendars',
	],
	columns: createStandardTaskColumns(),
	defaultSortId: 'column-due-date-column-asc',
	filterRules: {
		taskAssignedUser: {
			// PD-15470: a default, deliberately NOT a lock. The list still opens
			// on "my tasks", but a rep without `tasks:view:any` can now widen the
			// assignee filter to see a colleague's task on an account they rep.
			// The lock used to be the only thing scoping this list, and because
			// the controller feeds an enforced value straight into the query it
			// also ANDed away the new union. Visibility is now bounded
			// server-side by TasksService (`queryTasks` and `queryCalendarTasks`
			// both apply "assigned to me OR client in my book"), so widening the
			// filter here cannot widen what the API returns.
			defaultValue: [{ id: 'ME', label: 'Me' }],
		},
		taskDueDateRange: {
			defaultValue: [
				{
					id: 'this-week',
					label: 'This Week',
					data: {
						startDate: '{{DATE:start_of_week}}',
						endDate: '{{DATE:end_of_week}}',
					},
				},
			],
		},
		taskStatus: {
			defaultValue: [{ id: 'pending', label: 'Pending' }],
		},
	},
};
